import { initializeApp, getApp, getApps } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { initializeFirestore, getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getAnalytics, isSupported } from "firebase/analytics";

export const firebaseConfig = {
  apiKey: "AIzaSyAQR0SG68j8RxS0tKDVcGau-ZiQ9VwOX-o",
  authDomain: "classboon.firebaseapp.com",
  projectId: "classboon",
  storageBucket: "classboon.appspot.com",
  messagingSenderId: "479379000350",
  appId: "1:479379000350:web:0e0a7e1a399b10aa21320f",
  measurementId: "G-ELX885FFE3",
};

const firstInit = getApps().length === 0;
const app = firstInit ? initializeApp(firebaseConfig) : getApp();

// App Check — bot/abuse protection at the source. Attaches a reCAPTCHA
// Enterprise attestation to every Firebase request so automated sign-ups (and
// other scripted abuse) are rejected before they ever create an account. Google
// deprecated classic reCAPTCHA v3 for new keys, so this uses the Enterprise
// provider (the site key is a reCAPTCHA Enterprise key). Only initializes when a
// site key is configured, so local dev / preview builds without the key still
// run untouched. For local testing set REACT_APP_APPCHECK_DEBUG=true and
// register the token it logs under Firebase → App Check → apps → Manage debug
// tokens.
if (firstInit && process.env.REACT_APP_APPCHECK_SITE_KEY) {
  if (process.env.REACT_APP_APPCHECK_DEBUG === "true") {
    // eslint-disable-next-line no-restricted-globals
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(process.env.REACT_APP_APPCHECK_SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

export const auth = getAuth(app);

// Auto-detect long polling so the realtime connection survives school/district
// SSL-inspection proxies and legacy filters that break Firestore's default
// streaming transport (WebChannel) — without this the app can silently "freeze"
// on locked-down networks. initializeFirestore must run exactly once per app, so
// only the first init sets it; later imports (hot reload) reuse the instance.
export const firestore = firstInit
  ? initializeFirestore(app, { experimentalAutoDetectLongPolling: true })
  : getFirestore(app);

export const functions = getFunctions(app);

// Google Analytics (GA4, measurementId above) — only initializes in supported
// (browser) environments, so SSR / unsupported browsers run untouched.
export let analytics = null;
if (firstInit) {
  isSupported()
    .then((ok) => {
      if (ok) analytics = getAnalytics(app);
    })
    .catch(() => {
      /* analytics unavailable (e.g. SSR / unsupported browser) — ignore */
    });
}

// Local development against the Firebase emulators (never in production builds).
// Enable with REACT_APP_USE_EMULATOR=true (e.g. for end-to-end verification).
if (firstInit && process.env.REACT_APP_USE_EMULATOR === "true") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(firestore, "127.0.0.1", 8080);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  // eslint-disable-next-line no-console
  console.log("[classBoon] Using Firebase emulators (auth:9099, firestore:8080, functions:5001)");
}

export default app;
